import { BlankLayout } from '@/components/layouts';

export default {
  path: '/trainingcamp',
  name: 'TrainingCamp',
  component: BlankLayout,
  meta: { module: '新手集训营' },
  children: [
    {
      path: '/trainingcamp/enroll/:id',
      name: 'TrainingCamp.Enroll',
      component: () => import(/* webpackChunkName: 'enroll' */ '@/views/training-camp/Enroll.vue'),
      meta: { title: '立即报名 - 新手集训营', titleAlias: '立即报名 - 新手集训营', hideBanner: true },
    },
    {
      path: '/trainingcamp/order/:seriesChannelId/:courseSeriesId',
      name: 'TrainingCamp.Order',
      component: () => import(/* webpackChunkName: 'train-order' */ '@/views/training-camp/Order.vue'),
      meta:
      {
        title: '付费报名 - 新手集训营', hideBanner: true, titleAlias: '付费课支付',
      },
    },
    {
      path: '/trainingcamp/miniprogram-qrcode',
      name: 'TrainingCamp.MiniProgramQrcode',
      component: () => import(/* webpackChunkName: 'training-camp-miniprogram-qrcode' */ '@/views/training-camp/MiniProgramQrcode.vue'),
      meta: { title: '扫码进群', hideBanner: true },
    },
  ],
};
